import { MenuItem } from "@shopify/hydrogen/storefront-api-types"
import FacebookIcon from "~/assets/icons/FacebookIcon"
import InstagramIcon from "~/assets/icons/InstagramIcon"
import LinkedinIcon from "~/assets/icons/LinkedinIcon"
import MailHeader from "~/assets/icons/MailHeader"
import PhoneHeader from "~/assets/icons/PhoneHeader"
import PinterestIcon from "~/assets/icons/PinterestIcon"
import SearIcon from "~/assets/icons/SearchIcon"
import TwitterIcon from "~/assets/icons/TwitterIcon"
import VisitHeader from "~/assets/icons/VisitHeader"
import YoutubeIcon from "~/assets/icons/YoutubeIcon"
import { Drawer } from "~/rs-components/global"
import Navigation from "~/rs-components/global/navigation/Navigation.client"
import WishButtonIcon from "../custom_icons/WishButtonIcon"
import { contactInfo, footer, header } from "../settings"
import { wishlistButtonNextTitle, routeWishList, isBrochure, brochureWishlistCookie } from "../settings/__product"
import { useEffect, useState } from "react"
import SearchIcon from "~/assets/icons/SearchIcon"
import Logo from "~/assets/icons/Logo"
type SetupMenuDrawerProps = {
    onClose: () => void,
    showCategory: string | boolean,
    setShowCategory: React.Dispatch<React.SetStateAction<string | boolean>>,
    goTo: (path: string) => void,
    storeName: string,
    menuItems: MenuItem[],
    shopSettings: any
}
export default function SetupMenuDrawer({ onClose, showCategory, setShowCategory, goTo, storeName, menuItems, shopSettings }: SetupMenuDrawerProps) {
    const [wishlistCount, setWishlistCount] = useState(0);
    const hideBrandsKiosk : boolean = header.hiddenBrand;
    const hiddenProductRanges : boolean = header.hiddenProductRanges;
    useEffect(() => {
            const wishlist = getWishlistCount();
            setWishlistCount(wishlist.length);
            const handleWishlistUpdate = (event: Event) => {
                const customEvent = event as CustomEvent;
                setWishlistCount(customEvent.detail);
            };
            window.addEventListener('wishlistUpdated', handleWishlistUpdate);
            return () => {
                window.removeEventListener('wishlistUpdated', handleWishlistUpdate);
            };
    }, []);
    const getWishlistCount = () => {
        const cookies = document.cookie.split(';');
        for (const cookie of cookies) {
            const [cookieName, cookieValue] = cookie.trim().split('=');
            if (cookieName === brochureWishlistCookie.WISHLIST_COOKIE_NAME) {
                return JSON.parse(decodeURIComponent(cookieValue));
            }
        }
        return [];
    };
    return (
        <>
            <div className="grid">
                <br />
            <img className='menuLogo' src={footer.logo}></img>
            <nav className="grid gap-4 p-6 sm:gap-6 sm:px-12 sm:py-8">
<div className="topUserAreaResponsive open loginCart basis-3/12 text-right mb-10">
    <div className="topUserAreaResponsive__search-container">
        <div className="topUserAreaResponsive__search">
            <form action={`/products`} method="GET">
                <input name="search" type="search" placeholder="Search..." />
                <i className="fa fa-search">
                    <button type='submit' className='buttonSearch'>
                        <SearchIcon />
                    </button>
                </i>
            </form>
        </div>
    </div>
</div>
<div className="text-left fixLink">
    {!hideBrandsKiosk &&  <a href="/brands"><span className="">Brands</span></a>}
    {!hiddenProductRanges && <a href="/product-ranges"><span className="">Product Ranges</span></a> }
    <a href="/products"><span className="">All Products</span></a>
    <a className="btn-contacts" href="/contacts"><span>Contacts</span></a>
</div>
                    <Navigation css={""} menuItems={menuItems} showCategory={showCategory} setShowCategory={setShowCategory} onClose={onClose} mobile shopSettings={shopSettings} />
                    <div className="wishListResonsive">
                        {wishlistButtonNextTitle &&
                            <div className={`topUserArea__login ${isBrochure ? 'brochure' : ''} ${wishlistCount > 0 ? '' : 'empty'}`}>
                                <a href={routeWishList}><WishButtonIcon />
                                    {isBrochure && (
                                        wishlistCount > 0 && (<p className="wishlist-counter">{wishlistCount}</p>)
                                    )}
                                    <p>Wishlist</p>
                                </a>
                            </div>
                        }
                    </div>
                   
                    <div className="responsiveMenu__socialIcons">
                        {contactInfo?.facebook && <a href={contactInfo?.facebook}><FacebookIcon /></a>}
                        {contactInfo?.instagram && <a href={contactInfo?.instagram}><InstagramIcon /></a>}
                        {contactInfo?.twitter && <a href={contactInfo?.twitter}><TwitterIcon /></a>}
                        {contactInfo?.pinterest && <a href={contactInfo?.pinterest}><PinterestIcon /></a>}
                        {contactInfo?.youtube && <a href={contactInfo?.youtube}><YoutubeIcon /></a>}
                        {contactInfo?.linkedin && <a href={contactInfo?.linkedin}><LinkedinIcon /></a>}
                    </div>
                </nav>
            </div>
            
        </>
    )
}